export const accessRightMenu = {
  superAdmin: [ 'events' , 'users' , 'communications' , 'communicationsSent', 'templates', 'setting' ,
    'certificate', 'certificate_new', 'certificate_detail',
    'organizer-settings' , 'event-settings', 'organizer-settings_new' , 'organizer-settings_detail' ,
    'admin-users-settings' , 'areas-settings' , 'credits-system-settings' ,
    'blog' , 'statistic' , 'manager' , 'documents' , 'pictures' , 'accounts' , 'canton' , 'canton_new' ,
    'canton_detail' , 'ngxdatatable' , 'profile' ,
    'organization', 'user_new', 'user_detail', 'events_new', 'events_detail', 'blogType',
    'organization_new' , 'organization_detail', 'level-settings', 'target-group', 'frontusers', 'frontUser_new' , 'frontusersnoactive',
    'frontusers_detail', 'frontusersnoactive_detail', 'confession', 'dynamicData', 'blog_new', 'blog_detail', 'email-builder',
    'tutorial', 'group', 'function', 'default', 'whatsapp', 'budget', 'personnel', 'projectSettings', 'logsHistory',
    'emailEditor', 'news', 'archive', 'running', 'genderType', 'eLearning', 'eLearning_detail', 'platforms', 'platforms_detail',
    'matrix', 'matrixPlatforms', 'modules', 'modules_detail', 'events_all',  'communicationsTemplates',
    'frontVerify', 'frontNoVerify', 'mat-modules', 'matrixModules', 'spaces', 'spaces_new', 'learn-category',
    'learn-category-menu', 'share-links', 'deletedEvents', 'delete-request', 'marketplaces', 'marketplaces_detail',
    'marketplaceCategory', 'marketplaceCategory_new', 'learningPaths', 'learningPaths_detail', 'competency',
    'competency_new', 'deleted',
    'event', 'event_detail',
    'forumTalk', 'forumBanner', 'forumNews', 'forumSystemText', 'forumStatistics',
    'parishOrganization', 'parishOrganization_detail', 'additionalFrontUserInfo'
  ] ,
  countryAdmin: [ 'events' , 'users' , 'communications' , 'communicationsSent', 'templates', 'setting' ,
    'certificate', 'certificate_new',
    'admin-users-settings' , 'areas-settings' , 'credits-system-settings' ,
    'blog' , 'statistic' , 'manager' , 'documents' , 'pictures' , 'tasks' , 'tasks_detail' , 'accounts' , 'canton' ,
    'canton_new' , 'canton_detail' , 'profile' ,
    'organization', 'user_new', 'user_detail', 'events_new', 'events_detail'
    , 'organization_new' , 'organization_detail', 'frontusers', 'frontUser_new', 'frontusers_detail', 'frontusersnoactive_detail',
    'calendar', 'blog_new', 'blog_detail',
    'tutorial', 'budget', 'personnel', 'news' , 'archive', 'running', 'eLearning', 'eLearning_detail',
    'events_all', 'communicationsTemplates', 'frontVerify', 'deletedEvents', 'deleted',
    'event', 'event_detail'] ,
  subCountryAdmin: [ 'events' , 'users' , 'communications' ,  'communicationsSent', 'templates', 'setting' ,
    'certificate', 'certificate_new',
    'event-cantons', 'admin-users-settings' , 'areas-settings' , 'credits-system-settings' ,
    'blog' , 'statistic' , 'manager' , 'documents' , 'pictures' , 'tasks' , 'tasks_detail' , 'profile' , 'organization'
    , 'organization_new' , 'organization_detail', 'user_new', 'user_detail', 'frontusers', 'frontUser_new',
    'frontusers_detail' , 'frontusersnoactive_detail', 'events_new',
    'events_detail'
    , 'blog_new', 'blog_detail',   'calendar', 'released-event', 'tutorial', 'whatsapp', 'budget',
    'personnel', 'news', 'archive' ,
    'running', 'eLearning', 'eLearning_detail', 'events_all', 'frontVerify', 'deletedEvents', 'recommend',
  'recommendEvent', 'recommendBlog', 'recommendElearning', 'deleted',
    'event', 'event_detail'] ,
  organisationAdmin: ['events' , 'users' , 'communications' , 'communicationsSent', 'templates',
    'certificate', 'certificate_new', 'certificate_detail',
    'setting' , 'admin-users-settings' ,
    'areas-settings' , 'credits-system-settings' ,
    'blog' , 'statistic' , 'manager' , 'documents' , 'pictures' , 'tasks' , 'tasks_detail' , 'profile', 'user_new',
    'user_detail', 'target-group',
    'frontusers', 'frontUser_new', 'frontusers_detail', 'frontusersnoactive_detail', 'events_detail' , 'events_new', 'blog_new',
    'organization', 'organization_detail',
    'blog_detail',   'calendar', 'released-event', 'tag', 'tutorial', 'frontusersnoactive', 'budget', 'personnel', 'news',
    'archive', 'running', 'eLearning', 'eLearning_detail', 'events_all', 'communicationsTemplates', 'frontVerify',
    'frontNoVerify', 'org-platform', 'org-modules', 'deletedEvents', 'delete-request',
    'recommendation', 'recommendation-event', 'recommendation-blog', 'recommendation-elearning', 'favorite', 'marketplaces',
    'marketplaces_detail', 'learningPaths', 'learningPaths_detail', 'orgCompetency', 'deleted',
    'event', 'event_detail', 'hubOverview', 'taskGroup'
  ] ,
  leader: [ 'events' , 'events_new', 'events_detail' ,  'communications' , 'communicationsSent', 'communicationsTemplates',
    'certificate', 'certificate_new',
    'blog'  , 'manager' , 'documents' , 'pictures' , 'profile', 'blog_new', 'blog_detail', 'calendar', 'tutorial',
    'news', 'archive' , 'running', 'eLearning', 'eLearning_detail', 'events_all', 'deletedEvents', 'deleted',
  'event', 'event_detail'] ,
  readOnly: [ 'events' , 'events_detail', 'blog'  , 'profile', 'blog_new', 'blog_detail',
    'calendar', 'tutorial', 'news', 'archive',
    'running' , 'eLearning', 'eLearning_detail', 'events_all', 'deletedEvents', 'deleted',
  'event', 'event_detail']
};
